"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: all[name]
    });
}
_export(exports, {
    MessageBarTransitionContextProvider: function() {
        return MessageBarTransitionContextProvider;
    },
    messageBarTransitionContextDefaultValue: function() {
        return messageBarTransitionContextDefaultValue;
    },
    useMessageBarTransitionContext: function() {
        return useMessageBarTransitionContext;
    }
});
const _interop_require_wildcard = require("@swc/helpers/_/_interop_require_wildcard");
const _react = /*#__PURE__*/ _interop_require_wildcard._(require("react"));
const messageBarTransitionContext = /*#__PURE__*/ _react.createContext(undefined);
const messageBarTransitionContextDefaultValue = {
    className: '',
    nodeRef: /*#__PURE__*/ _react.createRef()
};
const MessageBarTransitionContextProvider = messageBarTransitionContext.Provider;
const useMessageBarTransitionContext = ()=>{
    var _React_useContext;
    return (_React_useContext = _react.useContext(messageBarTransitionContext)) !== null && _React_useContext !== void 0 ? _React_useContext : messageBarTransitionContextDefaultValue;
};
